type AuthCheck = (url: string, onUnauthorized?: () => void) => Promise<unknown>;

let authCheck: AuthCheck;

export const setAuthCheck = (func: AuthCheck) => (authCheck = func);

export const getAuthCheck = async (url: string, onUnauthorized?: () => void): Promise<unknown> => {
    if (authCheck) {
        return authCheck(url, onUnauthorized);
    }
};
